export default {
	namespaced: true,
	state: {
		claim: {
			number: null,
			status: { id: null, code: null, name: null },
			vehicle: {
				number: null
			},
			applicant: {
				isOwner: null,
				role: { id: null, code: null, name: null },
				type: { id: null, code: null, name: null },
				phone: null,
			},
			documents: []
		},

		step: 0,
		windows: [],
	},
	getters: {
		claim(state) {
			return state.claim
		},
		step(state) {
			return state.step
		},
		elements(state) {
			let elements = state.claim?.dialog?.elements ? state.claim.dialog.elements : [];
			let result = elements

			let claimStatusCode = state.claim?.status?.code
			let claimApplicantRoleName = state.claim?.applicant?.role?.name
			let claimApplicantTypeName = state.claim?.applicant?.type?.name

			if(claimStatusCode === 'application') {
				result = elements.filter((element) => {
					if(claimApplicantRoleName === "Страхувальник") {
						return [
							'Oferta',
							'Identification',
							'Applicant',
							'AccidentScene',
							'RegistrationCertificate',
							'DriversLicense',
							'EuroProtocol',
							'PoliceDocument',
							'OtherDocument',
							'Summary'
						].includes(element.code)
					} else {
						if(claimApplicantTypeName === "юридична особа") {
							return [
								'Oferta',
								'Identification',
								'Applicant',
								'EDRPOU',
								'RegistrationCertificate',
								'DriversLicense',
								'EuroProtocol',
								'PoliceDocument',
								'AccidentScene',
								'CourtOrder',
								'TravelDocument',
								'PropertyRightsDocument',
								'OtherDocument',
								'Summary'
							].includes(element.code)
						} else {
							return [
								'Oferta',
								'Identification',
								'Applicant',
								'Passport',
								'Inn',
								'RegistrationCertificate',
								'DriversLicense',
								'EuroProtocol',
								'InsurancePolicy',
								'PoliceDocument',
								'CourtOrder',
								'AccidentScene',
								'PropertyRightsDocument',
								'OtherDocument',
								'Summary'

							].includes(element.code)
						}
					}
				})
			}

			//console.log('store', 'windows', 'result', result)

			return result

		},
		/* windows(state) {
			let result = state.windows

			//console.log('store', 'windows', 'state.claim', state.claim)
			//console.log('store', 'windows', 'state.claim', state.claim.status.code)

			//if(state.claim.status.code === null || state.claim.status.code === 'application') {
			if(state.claim.status.code === 'application') {
				result = state.windows.filter((window) => {
					if(state.claim.applicant.role.name === "Страхувальник") {
						return [
							'Oferta',
							'Identification',
							'Applicant',
							'AccidentScene',
							'RegistrationCertificate',
							'DriversLicense',
							'EuroProtocol',
							'PoliceDocument',
							'OtherDocument',
							'Summary'
						].includes(window.code)
					} else {
						if(state.claim.applicant.type.name === "юридична особа") {
							return [
								'Oferta',
								'Identification',
								'Applicant',
								'EDRPOU',
								'RegistrationCertificate',
								'DriversLicense',
								'EuroProtocol',
								'PoliceDocument',
								'AccidentScene',
								'CourtOrder',
								'TravelDocument',
								'PropertyRightsDocument',
								'OtherDocument',
								'Summary'
							].includes(window.code)
						} else {
							return [
								'Oferta',
								'Identification',
								'Applicant',
								'Passport',
								'Inn',
								'RegistrationCertificate',
								'DriversLicense',
								'EuroProtocol',
								'InsurancePolicy',
								'PoliceDocument',
								'CourtOrder',
								'AccidentScene',
								'PropertyRightsDocument',
								'OtherDocument',
								'Summary'

							].includes(window.code)
						}
					}
				})

				//console.log('store', 'windows', 'winds', winds)
				//console.log('store', 'windows', 'result', result)
			}

			//console.log('store', 'windows', 'result', result)

			return result
		}, */
		/* window(state) {
			return state.windows[state.step]
		}, */
	},
	mutations: {
		claim(state, data) {
			state.claim = data
		},
		step (state, data) {
			state.step = data
		},
		windows (state, data) {
			state.windows = data
		},
	},
	actions: {
		setClaim(context, data) {
			context.commit('claim', data)
		},

		createClaimDocument(context, code) {
			//console.log('createClaimDocument', 'code', code)

			let claim = context.getters.claim;

			const document = claim.documents.find((item) => item.type.code === code)
			if(!document) {
				claim.documents.push({
					type: { code: code },
					files: []
				})
			}

			//console.log('createClaimDocument', 'claim.documents', claim.documents)
			return document
		},

		setStep(context, data) {
			const elements = context.getters.elements;
			const maxindex = elements.length - 1;

			let step = isNaN(data) ? elements.findIndex((element) => element.code == data) : data;

			if(step >= 0 && step <= maxindex) {
				context.commit('step', step)
			}
		},

		previousStep(context) {
			const step = context.getters.step;
			if(step > 0) {
				context.commit('step', step - 1)
			}
		},

		nextStep(context) {
			const step = context.getters.step;
			const maxindex = context.getters.elements.length - 1;
			
			if(step < maxindex) {
				context.commit('step', step + 1)
			}
		},

		/* setWindows(context, windows) {
			if(windows) {
				context.commit('windows', windows)
				if(windows.length) {
					context.commit('step', 0)
				}
			} else {
				context.commit('windows', [])
			}
		}, */
	},
}
